module.exports = __webpack_public_path__ + "static/media/rimario.64440cbf.png";